// Teksten van de startpagina (Home.jsx) - Nederlandse vertaling van fr/home.js.
// Zelfde sleutels, zelfde volgorde. Merknamen (Joyful Reveal, Mirum Games,
// Pack Essentiel, Pack Premium) blijven onvertaald.
export default {
  'home.seo.titre': 'Joyful Reveal - Gender reveal spel: speel om het geslacht van de baby te onthullen | Mirum Games',
  'home.seo.description': 'Maak van uw gender reveal party een spel: 2 teams, grappige vragen, 11 puzzelstukjes om te winnen en een laatste stukje dat het geslacht van de baby onthult. Snelle levering in België en Frankrijk.',

  'home.etat.chargement': 'Laden...',

  'home.vitrine.badge': '🧩 Onze collectie',
  'home.vitrine.description': 'Een uniek concept dat de onthulling van het geslacht van de baby verandert in een leuk vraag-en-antwoordspel! Verzamel uw dierbaren, vorm teams en beleef samen dit magische moment dat u nooit meer vergeet.',
  'home.vitrine.altProduit': 'Joyful Reveal Beertjes - Ecologische puzzel die het geslacht van de baby onthult - Mirum Games',

  'home.packs.titre': 'Kies uw pack',
  'home.packs.economisez': 'Bespaar {pct}%',
  'home.packs.selectionne': '✓ Geselecteerd',
  'home.packs.selectionner': 'Selecteren',
  'home.packs.voirFiche': '📋 Bekijk de volledige productpagina',

  'home.recap.packChoisi': 'Gekozen pack:',
  'home.recap.prixTotal': 'Totaalprijs:',

  'home.genre.cestPour': 'Dit is voor...',
  'home.genre.contenuPack': 'Inhoud van het pack',
  'home.genre.packMixte': 'Gemengd pack: meisje + jongen inbegrepen!',
  'home.genre.versionGarcon': 'Versie Jongen voorgeselecteerd',
  'home.genre.versionFille': 'Versie Meisje voorgeselecteerd',

  // Variantlabels: gebruikt voor de knoppen Jongen/Meisje EN voor de
  // samengestelde productnaam in het winkelmandje (een sleutel per variant).
  'home.variante.garcon': 'Jongen',
  'home.variante.fille': 'Meisje',
  'home.variante.mixte': 'Meisje + Jongen',

  'home.cta.ajouterPanier': '🛒 Toevoegen aan winkelmandje',
  'home.cta.voirFichePack': '📋 Bekijk de volledige productpagina van {pack}',
  'home.cta.magique': '✨ Creëer een magisch moment met uw familie',

  'home.badges.cleEnMain': 'Kant-en-klaar',
  'home.badges.pretAOffrir': 'Cadeauklaar',
  'home.badges.livraisonRapide': 'Snelle levering',

  'home.concept.badge': '✨ Ons unieke concept',
  // Zinnen opgesplitst rond de <strong> : ervoor / sterk woord / erna.
  'home.concept.question': 'Een klein meisje? Een kleine jongen?',
  'home.concept.questionSuite': 'Kan iedereen om u heen niet wachten om te ontdekken van welk team uw kindje wordt?',
  'home.concept.annonce': 'Kondig het nieuws aan op een speelse en originele manier, met ons spel!',
  'home.concept.puzzleAvant': 'Deze puzzel is',
  'home.concept.puzzleMot': 'uniek',
  'home.concept.puzzleApres': 'want u bouwt hem stukje voor stukje op tijdens een leuk vraag-en-antwoordspel, om uiteindelijk het kleine geheim van de baby te onthullen.',
  'home.concept.experienceAvant': 'Veel meer dan een puzzel, dit is een',
  'home.concept.experienceMot': 'ervaring vol samenzijn en vreugde',
  'home.concept.experienceApres': 'met vrienden en familie. Verzamel uw dierbaren, vorm teams en geniet van dit unieke moment in uw leven!',
  'home.concept.cadeauAvant': 'Of u nu zelf aanstaande ouders bent of een',
  'home.concept.cadeauMot': 'Gender Reveal Party',
  'home.concept.cadeauApres': 'organiseert voor iemand die u dierbaar is: ons spel maakt van die dag gegarandeerd een nog onvergetelijker moment.',

  'home.instagram.badge': '📸 Magische momenten',
  'home.instagram.titre': 'Ontdek onze puzzel in actie! 🎉',
  'home.instagram.sousTitre': 'Kijk hoe onze klanten hun magische onthulling beleven met Joyful Reveal',
  'home.instagram.altReel': 'Twee aanstaande ouders omringd door puzzelstukjes, illustratie Joyful Reveal',
  'home.instagram.voirSur': 'Bekijken op Instagram',
  'home.instagram.momentTitre': 'Een onvergetelijk moment',
  'home.instagram.momentTexte': 'Onze puzzels maken van de onthulling een interactieve en feestelijke ervaring. Leg de stukjes samen met uw naasten en ontdek samen het grote geheim!',
  'home.instagram.jeuInteractif': 'Interactief spel',
  'home.instagram.enFamille': 'Met de hele familie',
  'home.instagram.suivezNous': 'Volg ons op Instagram',
};
